<template>
  <div class="container">
    <div class="logo">
      <router-link to="/"><img src="/img/logo.png" alt="" /></router-link>
    </div>
    <div class="login-wrapper">
      <div class="form-wrapper">
        <router-view />
      </div>
    </div>
    <FooterLogin />
  </div>
</template>

<script>
import Menu from "../components/Menu";
import FooterLogin from "../components/FooterLogin";
export default {
  name: "LoginLayout",
  components: {
    Menu,
    FooterLogin,
  },
};
</script>

<style lang="less" scoped>
.container {
  position: relative;
  width: 100%;
  height: 100vh;
  min-height: 900px;
  min-width: 1000px;
  // background: #f0f2f5 url(/img/background.svg) no-repeat 50%;
  background: @primary-color;
  .logo {
    position: absolute;
    top: 40px;
    left: 40px;
    height: 50px;
    img {
      height: 100%;
    }
  }
}
.login-wrapper {
  position: relative;
  top: 100px;
  width: 966px;
  height: 453px;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  background-size: 100%;
  background-position-y: bottom;
  background-repeat: no-repeat;
}
.form-wrapper {
  position: absolute;
  bottom: 0;
  height: 420px;
  width: 454px;
  padding: 60px 94px 44px;
  margin: 0 256px 32px;
  background: #fdfdfd;
  box-shadow: 0 0 4px 0px #d0d0d0;
}
</style>